import { generateClient } from "aws-amplify/api";
import { updateFieldInstance } from "../graphql/mutations";
import { updateFieldInstance as updateFI } from "../db/queries/fieldInstanceQueries";
import { FieldInstance, FieldInstanceForResolver } from "db/definitions";
import { recordSentry } from "./recordSentry";
import updateSingleFieldInstance from "./_updateSingleFieldInstance";

/**
 * Given a fieldInstance (table) document and whether or not the user is online, we update it in the relevant database
 * @param table The fieldInstance (Parent table field) that we want to update
 * @param online Whether or not the user is online
 * @returns The same table we passed in
 */
async function updateTable(
	table: Pick<FieldInstance | FieldInstanceForResolver, "id" | "formInstance" | "formGroup" | "fieldTemplateId" | "fieldsOrder" | "authors" | "group"> &
		Partial<FieldInstance | FieldInstanceForResolver>,
	online: boolean,
) {
	const updatedTable: Pick<FieldInstanceForResolver, "id" | "formGroup" | "group"> & Partial<FieldInstanceForResolver> = {
		id: table.id,
		formInstance: table.formInstance,
		formGroup: table.formGroup,
		fieldTemplateId: table.fieldTemplateId,
		fieldsOrder: table.fieldsOrder,
		authors: table.authors,
		group: table.group,
	};

	if (table.sortingPriority) updatedTable.sortingPriority = table.sortingPriority;
	if (table.forceUpdateData) updatedTable.forceUpdateData = table.forceUpdateData;
	if (table.updatedAt) updatedTable.updatedAt = table.updatedAt;
	if (online) {
		try {
			await updateSingleFieldInstance(updatedTable);
		} catch (error) {
			recordSentry({ error });
		}
	} else {
		updatedTable.touched = 1;
		await updateFI(updatedTable);
	}

	return updatedTable;
}

export default updateTable;
